(function ($) {

// Modified from https://webglfundamentals.org/webgl/lessons/webgl-2d-matrices.html

    /**
     *
     *
     * @class Mat3
     * @classdesc A left-to-right matrix representation, useful for affine transforms for
     * positioning tiles for drawing
     *
     * @memberof OpenSeadragon
     *
     * @param {Array} [values] - Initial values for the matrix
     *
     **/
    class Mat3 {
        constructor(values) {
            if (!values) {
                values = [
                    0, 0, 0,
                    0, 0, 0,
                    0, 0, 0
                ];
            }
            this.values = values;
        }

        /**
         * @function makeIdentity
         * @memberof OpenSeadragon.Mat3
         * @static
         * @returns {OpenSeadragon.Mat3} an identity matrix
         */
        static makeIdentity() {
            return new Mat3([
                1, 0, 0,
                0, 1, 0,
                0, 0, 1
            ]);
        }

        /**
         * @function makeTranslation
         * @memberof OpenSeadragon.Mat3
         * @static
         * @param {Number} tx The x value of the translation
         * @param {Number} ty The y value of the translation
         * @returns {OpenSeadragon.Mat3} A translation matrix
         */
        static makeTranslation(tx, ty) {
            return new Mat3([
                1, 0, 0,
                0, 1, 0,
                tx, ty, 1,
            ]);
        }

        /**
         * @function makeRotation
         * @memberof OpenSeadragon.Mat3
         * @static
         * @param {Number} angleInRadians The desired rotation angle, in radians
         * @returns {OpenSeadragon.Mat3} A rotation matrix
         */
        static makeRotation(angleInRadians) {
            var c = Math.cos(angleInRadians);
            var s = Math.sin(angleInRadians);
            return new Mat3([
                c, -s, 0,
                s, c, 0,
                0, 0, 1,
            ]);
        }

        /**
         * @function makeScaling
         * @memberof OpenSeadragon.Mat3
         * @static
         * @param {Number} sx The x value of the scaling
         * @param {Number} sy The y value of the scaling
         * @returns {OpenSeadragon.Mat3} A scaling matrix
         */
        static makeScaling(sx, sy) {
            return new Mat3([
                sx, 0, 0,
                0, sy, 0,
                0, 0, 1,
            ]);
        }

        /**
         * @alias multiply
         * @memberof! OpenSeadragon.Mat3
         * @param {OpenSeadragon.Mat3} other the matrix to multiply with
         * @returns {OpenSeadragon.Mat3} The result of matrix multiplication
         */
        multiply(other) {
            let a = this.values;
            let b = other.values;

            var a00 = a[0 * 3 + 0];
            var a01 = a[0 * 3 + 1];
            var a02 = a[0 * 3 + 2];
            var a10 = a[1 * 3 + 0];
            var a11 = a[1 * 3 + 1];
            var a12 = a[1 * 3 + 2];
            var a20 = a[2 * 3 + 0];
            var a21 = a[2 * 3 + 1];
            var a22 = a[2 * 3 + 2];
            var b00 = b[0 * 3 + 0];
            var b01 = b[0 * 3 + 1];
            var b02 = b[0 * 3 + 2];
            var b10 = b[1 * 3 + 0];
            var b11 = b[1 * 3 + 1];
            var b12 = b[1 * 3 + 2];
            var b20 = b[2 * 3 + 0];
            var b21 = b[2 * 3 + 1];
            var b22 = b[2 * 3 + 2];
            return new Mat3([
                b00 * a00 + b01 * a10 + b02 * a20,
                b00 * a01 + b01 * a11 + b02 * a21,
                b00 * a02 + b01 * a12 + b02 * a22,
                b10 * a00 + b11 * a10 + b12 * a20,
                b10 * a01 + b11 * a11 + b12 * a21,
                b10 * a02 + b11 * a12 + b12 * a22,
                b20 * a00 + b21 * a10 + b22 * a20,
                b20 * a01 + b21 * a11 + b22 * a21,
                b20 * a02 + b21 * a12 + b22 * a22,
            ]);
        }
    }


    $.Mat3 = Mat3;

}(OpenSeadragon));
